import { render, staticRenderFns } from "./RegraNegocio.vue?vue&type=template&id=758660d8"
import script from "./RegraNegocio.vue?vue&type=script&lang=js"
export * from "./RegraNegocio.vue?vue&type=script&lang=js"
import style0 from "@/views/Cashback/cashback-tema.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports